import { useState } from "react";
import { saveTaxCategory } from "../Api/TaxCategory";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const TaxCategory = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [taxCategoryData, setTaxCategoryData] = useState({
    code: "",
    description: "",
  });

  const handleChange = (e) => {
    setTaxCategoryData({ ...taxCategoryData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveTaxCategory(taxCategoryData);
      toast.success("🦄 Tax Category Added Successfully!");
      setTaxCategoryData({ code: "", description: "" });
      navigate("/viewTaxCategory");
    } catch (error) {
      toast.error("🦄 Some Error Happened");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Tax Category</h2>
            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Code <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="code"
                      value={taxCategoryData.code}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Description <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="description"
                      value={taxCategoryData.description}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Tax Category
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      
      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default TaxCategory;